export const pokemonRandomizerContent = {
  introduction: {
    titleKey: "pokemonRandomizer_whatIsItTitle",
    content: [
      `ポケモンランダマイザーは、あなたのポケモンアドベンチャーに予測不可能性と興奮の新しい波を注入するために設計された特別なツールです。ポケモンの遭遇、アイテムの場所、キャラクターの能力、さらにはタイプの相性など、さまざまなゲーム要素をシャッフルすることにより、ポケモンランダマイザーツールは毎回ユニークなゲームプレイ体験を作り出します。新しい挑戦を求めているベテラントレーナーであれ、ポケモンの世界を新しい方法で探求したい初心者であれ、私たちのランダマイザーは無限の可能性を提供します。何が起こるかわからないポケモンのバージョンに飛び込み、あなたの戦略的スキルがまったく新しい方法で試されます！`
    ],
  },
  features: {
    titleKey: "pokemonRandomizer_featuresTitle",
    content: [
      `私たちのポケモンランダマイザーは、最大限の楽しさとカスタマイズのために設計された包括的な機能スイートで際立っています。好みに合わせてランダム化を調整し、シャッフルする要素を選択できます。特定のルートの野生のポケモンから、受け取るスターター、さらには見つけるアイテムまで、コントロールはあなたの手の中にあります。私たちはシームレスなユーザーエクスペリエンスを優先し、ポケモンランダマイザーが使いやすく、高速で、新鮮なポケモンジャーニーへのあなたの欲求と互換性があることを保証します。高度なオプションにより微調整が可能になり、カジュアルなプレイスルーとヌズロック風のチャレンジの両方に最適なランダマイザーになります。`
    ],
  },
  whyUse: {
    titleKey: "pokemonRandomizer_whyUseTitle",
    content: [
      `ポケモンランダマイザーを使用すると、古典的なポケモンの公式が活性化され、信じられないほどの再現性が提供されます。それは古い習慣を打ち破り、あなたが考えもしなかったかもしれないポケモンチームで戦略を立てることを強制します。各プレイスルーは、予期せぬ遭遇と挑戦に満ちたユニークな物語になります。これは、コンテンツ作成者が魅力的なポケモンコンテンツを生成したり、ファンがお気に入りの地域をまったく新しいレンズを通して再発見したりするための優れた方法です。標準的なポケモンのゲームプレイからの逸脱を求めているなら、ランダマイザーは数え切れないほどの時間の新しいエンターテイメントへの入り口です。`
    ],
  },
  gettingStarted: {
    titleKey: "pokemonRandomizer_gettingStartedTitle",
    content: [
      `私たちのツールで最初のポケモンランダマイザーアドベンチャーに飛び込むのは簡単です！私たちのジェネレーターに移動し、遭遇の特定の世代、タイプ、希少度レベルなど、ランダム化に必要なフィルターを選択します。簡単なチームのアイデアを探している場合は生成するポケモンの数を決定するか、完全なランダム化されたプレイスルーの準備をします。私たちの直感的なインターフェースはオプションを案内し、完璧なランダム化されたポケモン体験を簡単に設定できるようにします。「生成」をクリックして、ランダム性を展開させましょう！`
    ],
  },
  faq: {
    titleKey: "pokemonRandomizer_faqTitle",
    content: [
      `**このポケモンランダマイザーは無料で使用できますか？** もちろんです！私たちのツールはすべてのポケモンファンに完全に無料です。`, 
      `**特定のポケモンゲームにこのランダマイザーを使用できますか？** 私たちのツールはすべての世代のデータに基づいてランダムなポケモンを生成しますが、主にランダムなリストやチームを作成するためのものです。ゲーム内ランダマイザーの場合、通常、ゲームROMを変更するソフトウェアが必要です。私たちのツールはインスピレーションと挑戦のアイデアを提供します。`, 
      `**ポケモンランダマイザーはどの程度ランダムですか？** 設定したパラメーター内で高度なランダム性を確保するために堅牢なアルゴリズムを利用し、真に予測不可能で公正なエクスペリエンスを提供します。`, 
      `**ポケモンランダマイザーの設定を保存できますか？** 現在、設定は単一のセッション用ですが、ユーザーのフィードバックに基づいて常に新しい機能を追加することを目指しています！`
    ],
  },
};

export default pokemonRandomizerContent; 